<template>
        <crud-update :open="open"
                 :loading="loading || loadingUser"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <invira-user-form ref="form" v-model="form" :input-errors="inputErrors" :password-required="false" />
    </crud-update>
</template>

<script>

    import UserProvider from "../../../providers/UserProvider";
    
    import { CrudUpdate } from '@dracul/common-frontend'
    import { ClientError } from "../../../../../errors";
    
    import InviraUserForm from "../InviraUserForm";
  
    

    export default {
        name: "InviraUserUpdate",
        
        components: { InviraUserForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'admin.inviraUser.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                loadingUser: false,
                fullUserData: null,
                form: {
                    id: this.item.id,
                    username: this.item.username || '',
                    email: this.item.email || '',
                    password: '',
                    companyId: this.item.company ? this.item.company.id : null,
                    roleId: this.item.role ? this.item.role.id : null,
                    depositoIds: [],
                    active: this.item.active !== undefined ? this.item.active : true
                }
            }
        },
        watch: {
            open: {
                handler(newVal) {
                    if (newVal && this.item && this.item.id) {
                        // When dialog opens, fetch full user data including depositoIds
                        this.loadFullUserData()
                    }
                },
                immediate: true
            },
            item: {
                handler(newVal) {
                    if (newVal && newVal.id) {
                        // Initialize form with basic data from item (full user data is loaded by open watcher to avoid duplicate adminUserFind)
                        this.form = {
                            id: newVal.id,
                            username: newVal.username || '',
                            email: newVal.email || '',
                            password: '',
                            companyId: newVal.company ? newVal.company.id : null,
                            roleId: newVal.role ? newVal.role.id : null,
                            depositoIds: [],
                            active: newVal.active !== undefined ? newVal.active : true
                        }
                    }
                },
                immediate: true
            },
            fullUserData: {
                handler(newVal) {
                    if (newVal && newVal.id) {
                        // Ensure depositoIds and roleId are strings to match item-value format
                        const depositoIds = (newVal.depositoIds || []).map(id => String(id))
                        const roleId = newVal.role ? String(newVal.role.id) : null
                        
                        this.form = {
                            ...this.form,
                            id: newVal.id,
                            username: newVal.username || '',
                            email: newVal.email || '',
                            companyId: newVal.company ? newVal.company.id : null,
                            roleId: roleId,
                            depositoIds: depositoIds,
                            active: newVal.active !== undefined ? newVal.active : true
                        }
                    }
                }
            }
        },
        methods: {
            loadFullUserData() {
                if (!this.item || !this.item.id) return
                
                this.loadingUser = true
                UserProvider.findUser(this.item.id)
                    .then(r => {
                        if (r && r.data && r.data.adminUserFind) {
                            this.fullUserData = r.data.adminUserFind
                        }
                    })
                    .catch(error => {
                        console.error('Error loading full user data:', error)
                        // Fallback to item data if fetch fails
                        this.fullUserData = this.item
                    })
                    .finally(() => {
                        this.loadingUser = false
                    })
            },
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    // Remove password if empty and remove id (it's sent as a separate parameter)
                    const updateData = { ...this.form }
                    delete updateData.id // Remove id from input, it's sent as a separate parameter
                    if (!updateData.password) {
                        delete updateData.password
                    }
                    // Ensure depositoIds is always included, even if empty array
                    // Convert to array of strings and filter to only include valid IDs
                    // that are actually available in the depositos list (belong to user's company)
                    const depositoIds = (this.form.depositoIds || []).map(id => String(id).trim())
                    
                    // Get depositos from form component to validate against
                    const availableDepositoIds = this.$refs.form && this.$refs.form.depositos 
                        ? new Set(this.$refs.form.depositos.map(d => String(d.id).trim()))
                        : new Set()
                    
                    // Filter to only include depositos that are available for user's company
                    updateData.depositoIds = availableDepositoIds.size > 0
                        ? depositoIds.filter(id => availableDepositoIds.has(id))
                        : depositoIds // If no depositos loaded yet, send all (shouldn't happen in normal flow)
                    
                    UserProvider.updateUser(this.form.id, updateData).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.adminUserUpdate)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

